import { AcmMediaAsset } from 'src/app/core/clients/generated/client';
import { WistiaProjectsEnum } from 'src/app/shared/enums/wistia.enum';

export interface InvestmentStrategyModalData {
  Name: string;
  LogoUrls: LogoEnum[];
  RiskTolerance?: RiskToleranceEnum;
  MoneyManager?: MoneyManagerEnum;
  ManagerFee?: ManagerFeeEnum;
  FeeTier?: FeeTierEnum;
  ModelMinimum?: ModelMinimumEnum;
  IsBetaShield: boolean,
  Assets: AcmMediaAsset[];
  Error: boolean;
  Description?: string;
  InvestmentLinks?: InvestmentLinkModel[];
  IsSMA?: boolean;
  UseLogoContainer?: boolean;
}

export interface InvestmentStrategyModel {
  Id: string;
  Name: string;
  LogoUrl: LogoEnum;
  RiskTolerance: RiskToleranceEnum;
  MoneyManager: MoneyManagerEnum;
  ManagerFee?: ManagerFeeEnum;
  FeeTier: FeeTierEnum;
  ModelMinimum: ModelMinimumEnum;
  Tags: TagEnum[];
  Description?: string;
  InvestmentLinks?: InvestmentLinkModel[];
  IsSMA?: boolean;
  UseLogoContainer?: boolean;
}

export interface InvestmentLinkModel {
  Title: string;
  Link: string;
}

export interface InvestmentResourceModel {
  Id: string;
  Name: string;
  LogoUrls: LogoEnum[];
  Description: string;
  AdditionalDescription: string;
  WistiaProject: WistiaProjectsEnum;
}

export interface InvestmentStrategyFilters {
  RiskTolerance: RiskToleranceEnum[],
  MoneyManager: MoneyManagerEnum[],
  ModelMinimum: ModelMinimumEnum[],
  Tags: TagEnum[],
}

export interface InvestmentModelCheckboxFilter {
  Name: string | number;
  Checked: boolean;
}

export enum LogoEnum {
  Alphastar = './assets/images/logos/alphastar_mint_logo.png',
  Vanguard = './assets/images/logos/vanguard-icon.svg',
  Russell = './assets/images/logos/russell-icon.svg',
  Twin = './assets/images/logos/generic-bank-icon.svg',
  VanHulzen = './assets/images/logos/vanhulzen-icon.png',
  Inspire = './assets/images/logos/inspire-icon.svg',
  Invesco = './assets/images/logos/invesco-icon.svg',
  Simon = './assets/images/logos/simon-icon.svg',
  Madrona = './assets/images/logos/madrona-icon.png',
  AlternativeInvestment = './assets/images/logos/alternative-investment-icon.svg',
  Evolv = './assets/images/logos/evolv-logo-square.png',
  Luma = './assets/images/logos/luma-logo-blue.svg',
  Parametric = './assets/images/logos/parametric_logo.png',
  NuveenBrooklyn = './assets/images/logos/nuveen_brooklyn.png',
  AcmAlte = './assets/images/logos/ALTE_logo.png',
  AcmPrme = './assets/images/logos/PRME_logo.png',
  AcmSlct = './assets/images/logos/SLCT_logo_black_blue.png',
  Sage = './assets/images/logos/sage_logo.png',
}

export enum RiskToleranceEnum {
  Conservative = 'Conservative',
  ModeratelyConservative = 'Moderately Conservative',
  Moderate = 'Moderate',
  ModeratelyAggressive = 'Moderately Aggressive',
  Aggressive = 'Aggressive',
  Variable = 'Variable',
}

export enum ModelMinimumEnum {
  FiveHundred = 500,
  TwentyFiveHundred = 2500,
  FiveThousand = 5000,
  TenThousand = 10000,
  FifteenThousand = 15000,
  TwentyFiveThousand = 25000,
  FiftyThousand = 50000,
  OneHundredThousand = 100000,
  OneHundredTwentyFiveThousand = 125000,
  TwoHundredFiftyThousand = 250000,
  OneMillion = 1000000,
  TenMillion = 10000000,
}

export enum ManagerFeeEnum {
  Zero = 0,
  Five = 5,
  Ten = 10,
  Fifteen = 15,
  Seventeen = 17,
  TwentyTwo = 22,
  TwentyFive = 25,
  Thirty = 30,
  Forty = 40,
  FortyThree = 43,
}

export enum FeeTierEnum {
  One = 1,
  Two = 2,
}


export enum MoneyManagerEnum {
  Alphastar = 'Alphastar Capital Management',
  Vanguard = 'Vanguard',
  Russell = 'Russell',
  Twin = 'TWIN',
  VanHulzen = 'Van Hulzen',
  Inspire = 'Inspire',
  Invesco = 'Invesco',
  Parametric = 'Parametric',
  NuveenBrooklyn = 'Nuveen-Brooklyn',
  Sage = 'Sage'
}

export enum TagEnum {
  Growth = 'Growth',
  RiskMitigation = 'Risk Mitigation',
  Income = 'Income',
  TaxEfficient = 'Tax Efficient',
  Preservation = 'Preservation',
  SMA = 'SMA',
}
